import template from "./accept-invite.html";
import {acceptInviteController} from "./accept-invite.controller";

const AcceptInviteComponent = {
    template,
    controller: acceptInviteController,
    controllerAs: "acceptInvite"
};

export default AcceptInviteComponent;


// WEBPACK FOOTER //
// ./sources/components/auth/accept-invite/accept-invite.component.js